import { Navigate, Outlet } from "react-router-dom";
import { Loading } from "src/components/Loading";
import { useFeatureFlag } from "src/contexts/FeatureFlags/FeatureFlagContext";
import { useUserFeatureFlagsQuery } from "src/contexts/FeatureFlags/FeatureFlagContext.generated";
import { FeatureFlagType } from "src/generated/graphqlTypes";
import { useRouteParams } from "src/hooks/useRouteParams";
import { ProjectParams } from "src/routes/routesDef";
import { projectProductOfferingsRoute } from "src/routing/domains/projectsPaths";

/** Gates the v2 project Product Offerings pages (Overview, Options); or redirects to the v1 list if the flag is disabled. */
export function ProductOfferingsV2Layout() {
  const isProductOfferingsV2Enabled = useFeatureFlag(FeatureFlagType.ProductOfferingsV2);
  const { loading: flagsLoading } = useUserFeatureFlagsQuery();
  const { projectId } = useRouteParams<ProjectParams>();

  if (flagsLoading) return <Loading />;
  if (!isProductOfferingsV2Enabled) {
    return <Navigate to={projectProductOfferingsRoute.url({ projectId })} replace />;
  }

  return <Outlet />;
}
